import { defineMessages } from "react-intl"

export default defineMessages({
  addressLine1: {
    defaultMessage: "Address line 1",
    id: "src.components.WebAppPortal.Address.addressLine1",
  },
  addressLine2: {
    defaultMessage: "Address line 2",
    id: "src.components.WebAppPortal.Address.addressLine2",
  },
  addressLine1IsRequired: {
    defaultMessage: "Address line 1 is required",
    id: "src.components.WebAppPortal.Address.addressLine1IsRequired",
  },
  addressLine2IsRequired: {
    defaultMessage: "Address line 2 is required",
    id: "src.components.WebAppPortal.Address.addressLine1IsRequired",
  },
  city: {
    defaultMessage: "City",
    id: "src.components.WebAppPortal.Address.city",
  },
  cityIsRequired: {
    defaultMessage: "city is required",
    id: "src.components.WebAppPortal.Address.cityIsRequired",
  },
  externalDriverId: {
    defaultMessage: "Fiscal Code",
    id: "src.components.WebAppPortal.AccountCreation.externalDriverId",
  },
  externalDriverIdRequired: {
    defaultMessage: "Fiscal Code required",
    id: "src.components.WebAppPortal.DriverLicense.externalDriverIdRequired",
  },
  externalDriverIdShouldBeAlphaNumeric: {
    defaultMessage:
      "Fiscal Code must contain alpha numeric characters only a-z A-Z 0-9",
    id:
      "src.components.WebAppPortal.DriverLicense.externalDriverIdShouldBeAlphaNumeric",
  },
  next: {
    defaultMessage: "Next",
    id: "src.components.WebAppPortal.Address.next",
  },
  pleaseEnterYourAddress: {
    defaultMessage: "Please enter your address",
    id: "src.components.WebAppPortal.Address.pleaseEnterYourAddress",
  },
  state: {
    defaultMessage: "State",
    id: "src.components.WebAppPortal.Address.state",
  },
  stateIsRequired: {
    defaultMessage: "state is required",
    id: "src.components.WebAppPortal.Address.stateIsRequired",
  },
  zipCode: {
    defaultMessage: "Zip Code",
    id: "src.components.WebAppPortal.Address.zipCode",
  },
  zipCodeIsRequired: {
    defaultMessage: "Zip Code is required",
    id: "src.components.WebAppPortal.Address.zipCodeIsRequired",
  },
})
